
import "./App.css";
import Main from "./screens/main/screen";


function App() {
  // useEffect(() => {
  //   signUpUser("suniljha@iafsm.in", "Admin@12").then((value) => {
  //     if (value != null) {
  //       var data = {
  //         name: "Sunil Jha",
  //         email: "suniljha@iafsm.in",
  //         type: "SuperAdmin",
  //         id: "111111",
  //       };
  //       addData(data);
  //     }
  //   });
  // }, []);
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
